<template>
  <b-overlay :show="drag" no-wrap no-center>
    <template #overlay>
      <div class="overlay-box" v-on:drop.prevent="onDrop">
        <div class="overlay-border">
          <div class="overlay-label">ファイルをドロップ</div>
        </div>
      </div>
    </template>
  </b-overlay>
</template>

<style lang="scss" scoped>
.overlay-box {
  position: relative;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  .overlay-border {
    display: flex;
    position: absolute;
    width: 100%;
    height: 100%;
    border: 1px dashed #666666;

    .overlay-label {
      margin-left: auto;
      margin-right: auto;
      align-self: center;
      font-size: 28px;
      font-weight: 700;
    }
  }
}
</style>

<script lang="ts">
import { defineComponent } from "vue";
export default defineComponent({
  name: "drop-area-overlay",
  props: {
    /**
     *  ドラッグ状態
     *  ドラッグ状態はoverlay下の要素で制御
     *  (@dragover.prevent="drag = true" @dragleave.prevent="drag = false" v-on:drop.prevent="drag = false" を付与する)
     */
    drag: { type: Boolean, default: false },
  },
  setup(_props, { emit }) {
    /* ファイル追加(D&D) */
    const onDrop = (e: { dataTransfer: DataTransfer }): void => {
      const files = e.dataTransfer.files;
      emit("dropFiles", files);
    };

    return { onDrop };
  },
});
</script>
